// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__wYL2y","card":"Card_card__uFbbj","banner":"Card_banner__ZP45t","chip":"Card_chip__dQ2oq","titlewrapper":"Card_titlewrapper__eeAzc","pill":"Card_pill__-pY9F"};